<script setup lang="ts">
const props = defineProps<{
  size?: 'sm' | 'md' | 'lg' | 'xl'
  showGlow?: boolean
}>()

const sizeClasses = {
  sm: 'w-7 h-7',
  md: 'w-9 h-9',
  lg: 'w-10 h-10',
  xl: 'w-12 h-12'
}

const currentSize = props.size || 'md'
</script>

<template>
  <div :class="[sizeClasses[currentSize], 'relative inline-flex items-center justify-center']">
    <!-- Glow effect (optional) -->
    <div
      v-if="showGlow"
      class="absolute inset-0 bg-gradient-to-br from-orange-500 to-purple-600 rounded-lg blur-sm opacity-40 group-hover:opacity-60 transition-opacity"
    ></div>

    <!-- Logo container with gradient background - reduced padding -->
    <div class="relative bg-gradient-to-br from-orange-500 via-pink-500 to-purple-600 rounded-lg p-1.5 w-full h-full flex items-center justify-center shadow-md">
      <!-- Modern fitness icon SVG - simplified strong design -->
      <svg
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        class="w-[70%] h-[70%]"
      >
        <!-- Kettlebell design - more recognizable and attractive -->
        <g>
          <!-- Handle -->
          <path
            d="M12 8 C12 6, 14 5, 16 5 C18 5, 20 6, 20 8 L20 11 L12 11 Z"
            fill="white"
            opacity="0.95"
          />
          <!-- Handle inner -->
          <ellipse cx="16" cy="8" rx="3" ry="1.5" fill="white" opacity="0.3" />

          <!-- Main body -->
          <path
            d="M11 11 C11 11, 10 12, 10 15 C10 18, 10 22, 13 25 C14.5 26.5, 17.5 26.5, 19 25 C22 22, 22 18, 22 15 C22 12, 21 11, 21 11 Z"
            fill="white"
            opacity="0.95"
          />

          <!-- Body highlight -->
          <ellipse cx="16" cy="17" rx="4" ry="6" fill="white" opacity="0.2" />

          <!-- Shine effects -->
          <circle cx="14" cy="14" r="1.5" fill="white" opacity="0.6" />
          <circle cx="18" cy="16" r="1" fill="white" opacity="0.4" />
          <ellipse cx="16" cy="21" rx="2" ry="1" fill="white" opacity="0.3" />

          <!-- Base weight indicator lines -->
          <line x1="13" y1="23" x2="19" y2="23" stroke="white" stroke-width="0.5" opacity="0.5" />
          <line x1="14" y1="24" x2="18" y2="24" stroke="white" stroke-width="0.5" opacity="0.5" />
        </g>
      </svg>
    </div>
  </div>
</template>
